<template>
  <v-container fluid>
    <v-form v-model="valid">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>
            <span class="font-weight-medium"
              >{{ $t('ITEM.CREATE') }} {{ $t('PERSONS.ITEM') }}</span
            >
          </v-toolbar-title>

          <v-spacer />

          <v-btn dark color="indigo" @click="$router.go(-1)">
            {{ $t('BUTTON.BACK') }}
          </v-btn>
        </v-toolbar>
      </v-card>

      <v-row class="mt-4">
        <v-col cols="12" md="12" sm="12">
          <v-card tile>
            <v-card-title class="font-weight-regular">
              {{ $t('PERSONS.MAIN_INFORMATION') }}
            </v-card-title>

            <v-divider />

            <v-card-text>
              <person-form
                v-model="form"
                :errors="errors.get('person')"
                @update-prop="clearErrorByName($event, 'person')"
              />

              <personal-profile-form
                v-model="form.personal_profile"
                :errors="errors.get('personal_profile')"
                @update-prop="clearErrorByName($event, 'personal_profile')"
              />

              <v-card min-height="142" elevation="0" class="mt-2">
                <v-card-text class="pa-0">
                  <main-person-tabs-form
                    v-model="form"
                    :errors="errors"
                    @update-prop="clearErrorByName($event)"
                  />
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>

          <v-card tile class="mt-6">
            <v-card-title class="font-weight-regular">
              {{ $t('USERS.ACCESS_TO_THE_APP') }}
            </v-card-title>

            <v-divider />

            <v-card-text>
              <user-information-form
                v-model="form.user"
                :errors="errors.get('user')"
                @update-prop="clearErrorByName($event, 'user')"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-card
            tile
            :disabled="!(form.user && Object.keys(form.user).length > 1)"
          >
            <v-card-title class="font-weight-regular">
              {{ $t('APARTMENTS.ITEM') }}
            </v-card-title>

            <v-divider />

            <v-card-text>
              <inhabitant-form
                v-model="form.inhabitant"
                :errors="errors.get('inhabitant')"
                @update-prop="clearErrorByName($event, 'inhabitant')"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-spacer />
          <v-btn elevation="24" large color="primary" @click="create">
            {{ $t('BUTTON.CREATE') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import PersonForm from '@/modules/persons/components/forms/PersonForm';
import InhabitantForm from '@/modules/persons/components/forms/InhabitantForm';
import PersonalProfileForm from '@/modules/persons/components/forms/PersonalProfileForm';
import MainPersonTabsForm from '@/modules/persons/components/forms/MainPersonTabsForm';
import UserInformationForm from '@/modules/persons/components/forms/UserInformationForm';
import PersonInvoicesEmail from '@/modules/persons/components/mixins/person-invoices-email';

export default {
  name: 'PersonCreatePage',
  components: {
    PersonForm,
    PersonalProfileForm,
    MainPersonTabsForm,
    UserInformationForm,
    InhabitantForm
  },
  mixins: [errors, PersonInvoicesEmail],

  data: () => ({
    valid: false,
    userValid: false,
    form: {
      inhabitant: null,
      data_protection: {
        terms_accepted: false,
        dsg_accepted: false
      }
    }
  }),

  computed: {},

  watch: {
    'form.inhabitant.apartment_id': 'setPersonAddr'
  },

  methods: {
    ...mapActions('person', ['store']),

    setPersonAddr() {
      this.form = Object.assign(this.form, {
        personal_profile: { ...this.form.personal_profile }
      });

      this.form.personal_profile.street = this.form.inhabitant.apartment.building.street;
      this.form.personal_profile.zip = this.form.inhabitant.apartment.building.building_complex.zip;
      this.form.personal_profile.city = this.form.inhabitant.apartment.building.building_complex.city;
    },

    create() {
      let {
        user = null,
        personal_profile = null,
        inhabitant = null,
        ...person
      } = this.form;

      if (!inhabitant.apartment_id && !inhabitant.date_from) {
        inhabitant = null;
      }

      this.store({
        person,
        personal_profile,
        user,
        inhabitant
      })
        .then(() => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$router.push({ name: 'persons' });
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>
